import { Injectable } from '@angular/core';
import { RestService } from './rest.service';
import { Observable, of } from 'rxjs';
import { FlorderDetail, OrderDetail } from '../../store/edit-florder-detail/florder-detail.interface';
import { util } from '../../util/util';

@Injectable({ providedIn: 'root' })
export class CCRRestService {
  constructor(private restService: RestService) {}

  createCCR(florderDetail: OrderDetail): Observable<{ ccrNumber: string }> {
    const postData = this.createPostDataForCreate(florderDetail);
    // return Observable.of({ ccrNumber: '0400004397' }); // to test
    return this.restService.post<{ ccrNumber: string }>('/Ccr/create', postData);
  }

  editCCR(florderDetail: OrderDetail): Observable<{ ccrNumber: string }> {
    const postData = this.createPostDataForEdit(florderDetail);
    return this.restService.post<any>('/Ccr/update', postData);
  }

  private createPostData(florderDetail: OrderDetail) {
    const postData = {
      sealNumber: florderDetail.sealNumber,
      lineItem: florderDetail.ccr.ccrLineItems.map(m => {
        return {
          lineType: m.type,
          palletId: m.type !== 'packing' ? util.cleanValue(m.palletId) : undefined,
          packingId: util.cleanValue(m.packingId),
          packingStatus: util.cleanValue(m.packingStatus),
          logisticsVarietyPacking: util.cleanValue(m.logisticsVarietyPacking),
          packingsPerPallet: m.changed && m.changed.packingsPerPallet || m.packingsPerPallet,
          numberOfPallets: m.changed && m.changed.numberOfPallets || m.numberOfPallets,
          packingQuantity: m.changed && m.changed.packingQuantity || m.packingQuantity || util.toNumber(m.packingsPerPallet) * util.toNumber(m.numberOfPallets),
        };
      }),
    };
    return postData;
  }

  private createPostDataForCreate(orderDetail: OrderDetail) {
    return {
      ...this.createPostData(orderDetail),
      etmOrderNumber: orderDetail.etmOrderNumber,
      salesOrderNumber: orderDetail.salesOrderNumber,
      deliveryNumber: orderDetail.deliveryNumber,
      shipmentNumber: orderDetail.shipmentNumbers,
    }
  }

  private createPostDataForEdit(orderDetail: OrderDetail) {
    return {
      ...this.createPostData(orderDetail),
      ccrNumber: orderDetail.ccr.ccrNumber,
    }
  }

}
